// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PanelWrapper-titleText-djabR {
    margin: 0px;
    font-size: 16px;
    font-weight: 700;
}

.PanelWrapper-panelBorder-xLcWF {
    border-radius: 8px;
    border: 1px solid var(--primary-border);
    padding: 22px 25px;
    margin-bottom: 100px;
}

@media screen and (max-width: 767px) {
    .PanelWrapper-panelBorder-xLcWF {
        margin-bottom: 0px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ManageListing/PanelWrapper/PanelWrapper.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".titleText {\n    margin: 0px;\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.panelBorder {\n    border-radius: 8px;\n    border: 1px solid var(--primary-border);\n    padding: 22px 25px;\n    margin-bottom: 100px;\n}\n\n@media screen and (max-width: 767px) {\n    .panelBorder {\n        margin-bottom: 0px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleText": `PanelWrapper-titleText-djabR`,
	"panelBorder": `PanelWrapper-panelBorder-xLcWF`
};
module.exports = ___CSS_LOADER_EXPORT___;
